import storage from 'good-storage'
const TOKEN_KEY = 'wd__key__'
const SECRET = 'wd_secret'
const PHONE = 'wd__phone__'
const USERID = 'wd__userid__'
const MXACTIVENUM = 'wd__mxactivenum__' // 镁信跳转参数
const USERNAME = 'wd__username__' // 用户姓名
const USERGENDER = 'wd__gender__' // 用户性别


export function saveKey (value) {
  storage.set(TOKEN_KEY, value)
  return value
}

export function getKey () {
  return storage.get(TOKEN_KEY, null)
  // return '~a8bbc8bb9wahqb'
}

export function savePhone (value) {
  storage.set(PHONE, value)
  return value
}

export function getPhone () {
  return storage.get(PHONE, null)
}

export function saveUserId (value) {
  storage.set(USERID, value)
  return value
}

export function getUserId () {
  return storage.get(USERID, null)
}

export function saveSecret (value) {
  storage.set(SECRET, value)
  return value
}

export function getSecret () {
  return storage.get(SECRET, null)
}
export function saveMxActiveNum (value) {
  storage.set(MXACTIVENUM, value)
  return value
}

export function getMxActiveNum () {
  return storage.get(MXACTIVENUM, null)
}

export function saveCacheObject (key, value) {
  storage.set(key, value)
  return value
}

export function getCacheObject (key) {
  return storage.get(key, null)
}
